export * from './src/localdelivery-spi-v1-tpa-local-delivery-spi.context.js';
